import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import Envasado from '../../components/envasado/Envasado'
import { fetchFiltrarEnvasado, abrirDetallesEnvasado, abrirModalEnvasadoMultiDosisDesdeListadoPrincipal, editarEnvasado, lecturaRFIDEnvasado } from '../../actions/envasado/envasado'
import {obtenerDatosPanelControl} from '../../actions/panelControl/panelControl'

export function mapStateToProps (state) {
  return {
    envasado: {...state.envasado},
    combos: {
      comboEnvasado: state.combos.comboEnvasado
    },
    auth: state.auth,
    panelControl: state.panelControl.datosPanel,
    paginaActual: state.common.paginaActual,
    numeroRegistrosPorPagina: state.common.numeroRegistrosPorPagina
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      fetchFiltrarEnvasado,
      abrirDetallesEnvasado,
      abrirModalEnvasadoMultiDosisDesdeListadoPrincipal,
      editarEnvasado,
      obtenerDatosPanelControl,
      lecturaRFIDEnvasado
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Envasado))